<template>
    <div class="container">
        <div class="row centered">
            <label :class="['btn', 'btn-success', 'btn-file']">
                Upload Bulk Interactions <input 
                    type="file" 
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                    ref="uploader" 
                    style="display: none;" 
                    @change="fileSelected" />
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title: 'Upload bulk interactions file',
            }
    },
        methods: {
            async fileSelected () {
                var selectedFile = this.$refs.uploader.files[0];

                let formData = new FormData();
                formData.append('file', selectedFile);

                let errors = await romeApi.upload(`interaction/bulk/upload`, formData);
                this.$refs.uploader.value = null;

                if(errors && errors.length > 0){        
                    await modalService.multiLineInfo(errors, 'Interaction Validation Errors');
                } else {
                    await modalService.info("Bulk interactions successfully processed");
                }       

                this.$parent.close();  
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/history/modals/BulkInteractionUpload.vue